import { render, staticRenderFns } from "./VacationHistory.vue?vue&type=template&id=6fedcc24"
import script from "./VacationHistory.vue?vue&type=script&lang=js"
export * from "./VacationHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports